/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useState, useEffect, useRef } from "react";
import queryString from "query-string";
// import config from "../config";
import API from "../utils/API";

// import RehireStaffModal from "../components/employees/features/rehirestaff/RehireStaffModal";
import handleEvents from "../utils/infos/handleEvents";

const infoContextDefaultValues = {
  infos: {},
  userReportsAccess: [],
  selectAllReport: {},
  filters: {},
  defaultFilters: {},
  filterData: {},
  staffData: {},
  inputs: {},
  rehireModalRef: null,
  handleEvents: {},
  saveData: {},
  isReactivated: false,
  storeInfos: () => {},
  storeUserReportsAccess: () => {},
  storeSelectAllReport: () => {},
  storeFilters: () => {},
  storeFilterData: () => {},
  storeStaffData: () => {},
  storeInputs: () => {},
  storeSaveData: () => {},
  storeReactivate: () => {},
};

const InfoContext = createContext(infoContextDefaultValues);

export function InfoProvider({ children }) {
  const query = queryString.parse(window.location.search);
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const tab = queryParams.get("tab");
  //   const id = queryParams.get("id");
  const [infos, setInfos] = useState({
    tabActive: query?.tab ? query.tab : "employeeinfo",
    staff_id: query?.id ? parseInt(query.id) : 0,
    keyChange: 0,
    isNext: 0,
  });
  const [userReportsAccess, setUserReportsAccess] = useState([]);
  const [selectAllReport, setSelectAllReport] = useState({
    rep_group_id: 0,
    type: "",
  });
  const defaultFilters = {
    is_first_load: false,
    key_form: 0,
    active: "Y",
    is_expatriate: "no",
    employment: [
      {
        employment_type: "",
        start_date: "",
        end_date: "",
      },
    ],
    position_change: [
      {
        position: "",
        reason: "",
        start_date: null,
        end_date: null,
      },
    ],
    organization: [],
    branch: [],
    department: [],
    division: [],
    identification: [
      {
        id: null,
        type: "",
        name: "",
        number: "",
        expiration_date: "",
        description: "",
        link: "",
        updated_date: null,
      },
    ],
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [filterData, setFilterData] = useState({
    status: "",
    data: "",
    err: 0,
    err_msg: "",
    type: "",
  });
  const [staffData, setStaffData] = useState({});
  const [inputs, setInputs] = useState({});
  const rehireModalRef = useRef(null);
  const [saveData, setSaveData] = useState({});
  const [isReactivated, setReactivate] = useState(false);

  useEffect(() => {
    const tmpData = { ...infos };
    if (query?.tab !== undefined && query?.tab !== infos.tabActive) {
      tmpData.tabActive = query.tab;
      tmpData.isNext = 0;
      if (query?.isnext) {
        tmpData.isNext = parseInt(query.isnext);
      }
      setInfos(tmpData);
    }
  }, [query.tab, infos.keyChange, infos]);

  useEffect(() => {
    if (query?.id) {
      const mainFunc = async () =>
        await API.post("info/user/detail", {
          params: ({
            id: query.id,
            path: window.location.pathname,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("info user detail=", decrypt);
          if (decrypt?.status === "success" && decrypt?.data) {
            if (decrypt?.data?.photo) {
              const photoURL = decrypt.data.photo;
              decrypt.data.photo = [{ data_url: photoURL }];
            }
            decrypt.data.current_active = decrypt.data.active;
            decrypt.data.current_email = decrypt.data.email;
            setFilters({ ...decrypt.data });
          } else {
            setFilters({});
          }
        })
        .catch((err) => {
          console.log(err);
          setFilters({});
        });
    }
  }, [query?.id]);

  // useEffect(() => {
  //   if (rehireModalRef) {
  //     console.log("Passing Modal Ref to handleEvents"); // ✅ Debugging log
  //     handleEvents.setRehireModalRef(rehireModalRef);
  //   }
  // }, [rehireModalRef]);

  useEffect(() => {
    handleEvents.setContextFunctions({
      filters,
      filterData,
      storeFilterData: setFilterData,
      storeInfos: setInfos,
      storeFilters: setFilters,
      storeSaveData,
      saveData,
      infos,
      isReactivated,
      storeReactivate: setReactivate,
    });
  }, [filters, filterData, saveData, infos, isReactivated]);

  const storeInfos = (data) => {
    setInfos(data);
  };

  const storeUserReportsAccess = (data) => {
    setUserReportsAccess(data);
  };

  const storeSelectAllReport = (data) => {
    setSelectAllReport(data);
  };

  const storeFilters = (data) => {
    setFilters(data);
  };

  const storeFilterData = (data) => {
    setFilterData(data);
  };

  const storeStaffData = (data) => {
    setStaffData(data);
  };

  const storeInputs = (data) => {
    setInputs(data);
  };

  const storeSaveData = (data, isReset = false) => {
    if (isReset) {
      setSaveData({}); // เคลียร์ทุก key
    } else {
      setSaveData((prev) => ({ ...prev, ...data }));
    }
  };

  const storeReactivate = (data) => {
    setReactivate(data);
  };

  const value = {
    infos,
    userReportsAccess,
    selectAllReport,
    filters,
    defaultFilters,
    filterData,
    staffData,
    inputs,
    rehireModalRef,
    handleEvents,
    saveData,
    isReactivated,
    storeInfos,
    storeUserReportsAccess,
    storeSelectAllReport,
    storeFilters,
    storeFilterData,
    storeStaffData,
    storeInputs,
    storeSaveData,
    storeReactivate,
  };

  return (
    <InfoContext.Provider value={value}>
      {children}
      {/* <RehireStaffModal ref={rehireModalRef} /> */}
    </InfoContext.Provider>
  );
}

export const useInfo = () => useContext(InfoContext);

